/**
 * Player Stats — the roll-up blobs as an explorable table.
 *
 *   /stats/:garden            → LeagueTable       (rows = players, one season)
 *   /stats/:garden/:playerId  → PlayerSeasonTable (rows = seasons, one player)
 *
 * Deliberately not a copy of the Blitz player page. Blitz answers "tell me about
 * this player"; this answers "who leads the league in this, and who else is up
 * there" — same blobs, transposed.
 *
 * Which population we read (`garden`) follows the route's league environment
 * rather than being page state: NBA blobs live behind the NBA API host and
 * prospect blobs behind the draft host, so switching gardens is a navigation,
 * not a fetch. `App.tsx` wraps each route in the matching provider.
 */

import { Route, Routes } from "react-router-dom";

import { ExplorerEnvironment } from "../../../data/Cache";
import { useLeagueEnvironment } from "../../../data/LeagueEnvironmentProvider";
import { PlayerStatsGarden } from "../../../models/PlayerStats";
import LeagueTable from "./LeagueTable";
import PlayerSeasonTable from "./PlayerSeasonTable";
import PlayerStatsLayout from "./PlayerStatsLayout";

export function useGarden(): PlayerStatsGarden {
  return useLeagueEnvironment() === ExplorerEnvironment.NBA
    ? "nba"
    : "prospect";
}

export default function PlayerStats() {
  return (
    <Routes>
      <Route element={<PlayerStatsLayout />}>
        <Route index element={<LeagueTable />} />
        <Route path=":playerId" element={<PlayerSeasonTable />} />
      </Route>
    </Routes>
  );
}
